import { nghiencuu, doimoi, sohoa } from 'assets/images';
const whySTDV = [
  {
    title: 'Nghiên cứu, học tập',
    img: nghiencuu,
    description:
      '" Hỗ trợ đảng viên trong việc nghiên cứu, học tập các nghị quyết, quy định, chỉ thị, kết luận của Trung ương và của cấp ủy tỉnh; đồng thời cập nhật kịp thời, chính xác những thông tin thời sự của Đảng, Nhà nước, của tỉnh và các cấp ủy Đảng.'
  },
  {
    title: 'Đổi mới, nâng cao',
    img: doimoi,
    description:
      '" Hỗ trợ đảng viên trong việc nghiên cứu, học tập các nghị quyết, quy định, chỉ thị, kết luận của Trung ương và của cấp ủy tỉnh; đồng thời cập nhật kịp thời, chính xác những thông tin thời sự của Đảng, Nhà nước, của tỉnh và các cấp ủy Đảng.'
  },
  {
    title: 'Số hóa nghiệp vụ Đảng',
    img: sohoa,
    description:
      '" Hỗ trợ đảng viên trong việc nghiên cứu, học tập các nghị quyết, quy định, chỉ thị, kết luận của Trung ương và của cấp ủy tỉnh; đồng thời cập nhật kịp thời, chính xác những thông tin thời sự của Đảng, Nhà nước, của tỉnh và các cấp ủy Đảng.'
  },
  {
    title: 'Nghiên cứu, học tập',
    img: nghiencuu,
    description:
      '" Hỗ trợ đảng viên trong việc nghiên cứu, học tập các nghị quyết, quy định, chỉ thị, kết luận của Trung ương và của cấp ủy tỉnh; đồng thời cập nhật kịp thời, chính xác những thông tin thời sự của Đảng, Nhà nước, của tỉnh và các cấp ủy Đảng.'
  },
  {
    title: 'Đổi mới, nâng cao',
    img: doimoi,
    description:
      '" Hỗ trợ đảng viên trong việc nghiên cứu, học tập các nghị quyết, quy định, chỉ thị, kết luận của Trung ương và của cấp ủy tỉnh; đồng thời cập nhật kịp thời, chính xác những thông tin thời sự của Đảng, Nhà nước, của tỉnh và các cấp ủy Đảng.'
  },
  {
    title: 'Số hóa nghiệp vụ Đảng',
    img: sohoa,
    description:
      '" Hỗ trợ đảng viên trong việc nghiên cứu, học tập các nghị quyết, quy định, chỉ thị, kết luận của Trung ương và của cấp ủy tỉnh; đồng thời cập nhật kịp thời, chính xác những thông tin thời sự của Đảng, Nhà nước, của tỉnh và các cấp ủy Đảng.'
  }
];

export default whySTDV;
